import React, { useEffect } from "react";
import { assets } from "../assets/assets";
import { FaTwitter, FaYoutube, FaFacebookF, FaInstagram } from "react-icons/fa";
import { SiRazorpay } from "react-icons/si"; // Razorpay Icon
import { FaGooglePay, FaCcVisa, FaCcMastercard } from "react-icons/fa"; // Google Pay, Visa, Mastercard Icons
import { SiPhonepe } from "react-icons/si"; // PhonePe Icon
import { Link } from "react-router-dom";

const Footer = () => {
  // Scroll to the top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []); // Empty dependency array ensures this effect runs only once when the component is mounted

  return (
    <footer>
      {/* Main Footer Section */}
      <div className="footer bottom-0 bg-white text-black p-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-8">
        {/* Company Info Section (Wider Column) */}
        <section className="lg:col-span-2">
          <address className="text-sm">
            <img
              src={assets.logo}
              alt="Mammoth Streetwear logo"
              className="h-16 w-auto mb-4"
            />
            <p>Owned By RAJESH EKNATH ZALTE</p>
            <p>
              Email:{" "}
              <a href="mailto:info@mammothstreetwears.com">
                info@mammothstreetwears.com
              </a>
            </p>
            <p>
              Contact: <a href="tel:+917276765568">+91 72767 65568</a>
            </p>
            <p>
              Address: Office No-102, Kalpana Tarang Apt, Opp. Ranka
              <br />
              Jewellers, Karve Road, Erandwane, Pune-411004
            </p>
          </address>
        </section>

        {/* Information Section */}
        <nav>
          <h1 className="footer-title font-bold text-lg mb-2">Explore</h1>
          {[
            { name: "Home", path: "/" },
            { name: "Collection", path: "/collection" },
            { name: "Customization", path: "/customize" },
            { name: "About Us", path: "/about" },
            { name: "Contact Us", path: "/contact" }
          ].map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className="block text-gray-700 hover:text-[#FF4902] mb-1"
              onClick={() => window.scrollTo(0, 0)}
            >
              {item.name}
            </Link>
          ))}
        </nav>
        {/* <nav>
      <h6 className="footer-title font-bold text-lg mb-2">Information</h6>
      {["Home", "Collection", "Customization", "About Us", "Contact Us"].map((item, index) => (
        <Link
          key={index}
          to={`/${item.toLowerCase().replace(/\s+/g, "-")}`}
          className="block text-gray-700 hover:text-[#FF4902] mb-1"
          onClick={() => window.scrollTo(0, 0)}
        >
          {item}
        </Link>
      ))}
    </nav> */}

        {/* Services Section */}
        <nav>
          <h1 className="footer-title font-bold text-lg mb-2">Policies</h1>
          {[
            { name: "Terms & Conditions", path: "/termandc" },
            { name: "Careers at mammoth", path: "/career" },
            { name: "Cancellation Policies", path: "/return-exchange" },
            { name: "Site Map", path: "/sitemap" },
            { name: "Privacy Policy", path: "/privacy-policy" }
          ].map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className="block text-gray-700 hover:text-[#FF4902] mb-1"
              onClick={() => window.scrollTo(0, 0)}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        {/* Useful Links Section */}
        <nav className="w-full sm:w-64">
          <h1 className="footer-title font-bold text-lg mb-2">Useful Links</h1>
          {[
            { name: "My Account", path: "/profile" },
            { name: "Offline Store", path: "/oflinestore" },
            { name: "Become a Partner", path: "/became-a-partnar" },
            { name: "Blogs", path: "/" },
            { name: "POD and Bulk Order", path: "/" }
          ].map((item, index) => (
            <a
              key={index}
              href={item.path}
              className="block text-gray-700 hover:text-[#FF4902] mb-1"
              onClick={() => window.scrollTo(0, 0)}
            >
              {item.name}
            </a>
          ))}
        </nav>

        {/* Newsletter Section */}
        <form className="w-full sm:w-64 mr-8 sm:mr-4">
          <h1 className="footer-title font-bold text-lg mb-2">Newsletter</h1>
          <fieldset className="form-control w-full">
            <label className="label">
              <span className="label-text text-gray-700">
                Enter your email address
              </span>
            </label>
            <input
              type="text"
              placeholder="username@site.com"
              className="input input-bordered w-full"
            />
            <button className="btn bg-[#FF4902] text-white w-full mt-2">
              Subscribe
            </button>
          </fieldset>
        </form>
      </div>

      {/* Bottom Footer Section */}
      {/* Bottom Footer Section */}
      <div className="bg-[#FF4902] text-white py-4">
        <div className="flex flex-wrap justify-center sm:justify-between items-center container mx-auto px-6">
          {/* Copyright */}
          <p className="text-sm mb-2 sm:mb-0 text-center sm:text-left">
            © {new Date().getFullYear()} Mammoth Streetwear . All rights
            reserved.
          </p>

          {/* Partner Logos for small and medium screens */}
          <div className="flex flex-wrap justify-center gap-4 mb-2 sm:mb-0 sm:flex-nowrap">
            <div className="bg-white rounded-sm ">
              <img
                src={assets.flogo1}
                alt="Partner Logo 1"
                className="h-10 w-auto"
              />
            </div>
            <div className="bg-white rounded-sm ">
              <img
                src={assets.flogo2}
                alt="Partner Logo 2"
                className="h-10 w-auto"
              />
            </div>
            <div className="bg-white rounded-sm ">
              <img
                src={assets.flogo3}
                alt="Partner Logo 3"
                className="h-10 w-auto"
              />
            </div>
            <div className="bg-white rounded-sm ">
              <img
                src={assets.flogo4}
                alt="Partner Logo 4"
                className="h-10 w-auto"
              />
            </div>
            <div className="bg-white rounded-sm ">
              <img
                src={assets.flogo5}
                alt="Partner Logo 5"
                className="h-10 w-auto"
              />
            </div>
            <div className="bg-white rounded-sm ">
              <img
                src={assets.flogo6}
                alt="Partner Logo 6"
                className="h-10 w-auto"
              />
            </div>
          </div>

          {/* Social Media Icons */}
          <div className="flex space-x-4 justify-center sm:justify-start mt-4 sm:mt-0">
            <a
              href="https://x.com/Mammoth_StrWr"
              target="_blank"
              rel="noopener noreferrer"
              className="link text-white hover:text-blue-500"
              aria-label="Follow us on Twitter"
            >
              <FaTwitter className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
            <a
              href="https://youtube.com/@mammothstreetwears?si=O7hp4eO1rd1dY7fa"
              target="_blank"
              rel="noopener noreferrer"
              className="link text-white hover:text-red-600"
              aria-label="Visit our YouTube channel"
            >
              <FaYoutube className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
            <a
              href="https://www.facebook.com/mammothstreetwears/"
              target="_blank"
              rel="noopener noreferrer"
              className="link text-white hover:text-blue-700"
              aria-label="Follow us on Facebook"
            >
              <FaFacebookF className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
            <a
              href="https://www.instagram.com/mammothofficial_/"
              target="_blank"
              rel="noopener noreferrer"
              className="link text-white hover:text-pink-500"
              aria-label="Follow us on Instagram"
            >
              <FaInstagram className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
